import React from 'react';
import { CancelOrRescheduleSection, PaymentPageRow } from './PaymentPage.style';
import { ProfileInformation, Skeleton } from '@mindly/ui-components';

const PaymentSkeleton = () => {
  return (
    <>
      <PaymentPageRow className={'pb-30'}>
        <ProfileInformation isLoading={true} />
      </PaymentPageRow>

      <PaymentPageRow spaceBetween className={'pb-20'} style={{ gap: '30px', paddingBottom: '15px' }}>
        <Skeleton heightPx={63} />
        <Skeleton heightPx={63} />
      </PaymentPageRow>
      <PaymentPageRow className={'pb-20'} style={{ paddingBottom: '12px' }}>
        <Skeleton widthPx={171} heightPx={24} />
      </PaymentPageRow>
      <PaymentPageRow spaceBetween className={'pb-20'} style={{ gap: '30px' }}>
        <Skeleton heightPx={43} />
        <Skeleton heightPx={43} />
      </PaymentPageRow>
      <PaymentPageRow className={'pb-30'} style={{ display: 'flex', flexDirection: 'column', gap: '36px' }}>
        <Skeleton heightPx={40} />
        <Skeleton heightPx={48} />
      </PaymentPageRow>
      <PaymentPageRow border className={'pb-25'}>
        <CancelOrRescheduleSection>
          <Skeleton heightPx={30} widthPx={30} style={{ flexShrink: 0 }} />
          <Skeleton heightPx={35} />
        </CancelOrRescheduleSection>
      </PaymentPageRow>
      <PaymentPageRow border={true} className={'pb-25 pt-25'}>
        <Skeleton heightPx={97} />
      </PaymentPageRow>
      <PaymentPageRow border={true} className={'pb-25 pt-25'}>
        <div style={{ display: 'flex', gap: '16px', marginBottom: '19px' }}>
          <Skeleton widthPx={30} heightPx={30} style={{ flexShrink: 0 }} />
          <Skeleton heightPx={54} />
        </div>
        <div style={{ display: 'flex', gap: '16px' }}>
          <Skeleton widthPx={30} heightPx={30} style={{ flexShrink: 0 }} />
          <Skeleton heightPx={54} />
        </div>
      </PaymentPageRow>
    </>
  );
};

export default PaymentSkeleton;
